module.exports = __webpack_public_path__ + "static/media/emptybox.ec0a4d65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/emptybox.svg
// module id = 13
// module chunks = 1